import React, { useMemo } from "react";
import { Badge } from "react-bootstrap";
import LookupActionsCell from "./LookupActionsCell";

const useLookupColumns = ({ handleEdit, handleDelete }) => {
  return useMemo(
    () => [
      {
        accessorKey: "lookupGroup",
        header: "Group",
        cell: (info) => (
          <div className="fw-semibold text-white">
            {info.getValue()}
          </div>
        ),
      },
      {
        id: "itemsCount",
        accessorKey: "lookupValue",
        header: "Items Count",
        cell: (info) => (
          <Badge
            bg="dark"
            className="border border-secondary px-3 py-2"
          >
            {info.row.original.lookupValue?.total || 0} Items
          </Badge>
        ),
      },
      {
        id: "preview",
        accessorKey: "lookupValue",
        header: "Preview",
        cell: (info) => {
          const values = info.row.original.lookupValue?.data || [];
          return (
            <div className="d-flex flex-wrap gap-1">
              {values.slice(0, 3).map((item, index) => (
                <Badge key={index} bg="secondary">
                  {item.lookupLabel}
                </Badge>
              ))}
              {values.length > 3 && (
                <Badge bg="info">
                  +{values.length - 3}
                </Badge>
              )}
            </div>
          );
        },
      },
      {
        id: "actions",
        header: () => <div style={{ textAlign: "center", width: "100%" }}>ACTIONS</div>,
        enableSorting: false,
        cell: (info) => (
          <LookupActionsCell
            lookup={info.row.original}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        ),
      },
    ],
    [handleEdit, handleDelete]
  );
};

export default useLookupColumns;
